import type { PrimitiveType } from '#layers/data-model/types/schema/primitive-type';
import { parseDecimalValue, toDecimal } from '#layers/data-model/utils/schema/decimal-value';
import { parseInteger64Text } from '#layers/data-model/utils/schema/integer-64';
import { isPrimitiveTypeBoolean, isPrimitiveTypeDecimal, isPrimitiveTypeFloat, isPrimitiveTypeInteger, isPrimitiveTypeInteger64, isPrimitiveTypeJson } from '#layers/data-model/utils/schema/primitive-type';

export function serializeRawValue(value: unknown, type: PrimitiveType): string {
	if (value === null || value === undefined) return '';
	if (isPrimitiveTypeJson(type)) return JSON.stringify(value, null, 2);
	return String(value);
}

export function parseRawValue(text: string, type: PrimitiveType): unknown {
	if (text === '') return null;
	if (isPrimitiveTypeDecimal(type)) return toDecimal(text);
	if (isPrimitiveTypeInteger64(type)) return parseInteger64Text(text, type.name) ?? text;
	if (isPrimitiveTypeInteger(type)) return Number.parseInt(text, 10);
	if (isPrimitiveTypeFloat(type)) return Number.parseFloat(text);
	if (isPrimitiveTypeBoolean(type)) return text === 'true' || text === '1';
	if (isPrimitiveTypeJson(type)) return JSON.parse(text);
	return text;
}

export function validateRawValue(text: string, type: PrimitiveType): string | undefined {
	if (text === '') return undefined;

	if (isPrimitiveTypeDecimal(type)) {
		return parseDecimalValue(text) === undefined ? 'errors.invalid_decimal' : undefined;
	}

	if (isPrimitiveTypeInteger64(type)) {
		return parseInteger64Text(text, type.name) === undefined ? 'errors.invalid_integer' : undefined;
	}

	if (!isPrimitiveTypeJson(type)) return undefined;

	try {
		JSON.parse(text);
		return undefined;
	}
	catch {
		return 'errors.invalid_json';
	}
}
